import { color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const classNamePrefix = "umd-animation-line";
const baseStyles = {
  span: {
    display: "inline",
    position: "relative",
    backgroundPosition: "left bottom",
    backgroundRepeat: "no-repeat",
    transition: "background 0.5s"
  },
  link: {
    position: "relative",
    textDecoration: "none"
  }
};
const createSolidGradient = (color2) => `linear-gradient(${color2}, ${color2})`;
const createTwoColorGradient = (color1, color2) => `linear-gradient(to left, ${color1} 50%, ${color2} 50% 100%)`;
const getSlideUnderStyle = (color2) => ({
  ...baseStyles.span,
  backgroundSize: "0 2px",
  backgroundImage: createSolidGradient(color2)
});
const getSlideUnderTwoColorStyle = (baseColor, hoverColor) => ({
  ...baseStyles.span,
  backgroundImage: createTwoColorGradient(baseColor, hoverColor),
  backgroundPosition: "right bottom",
  backgroundSize: "200% 2px"
});
const getFadeUnderStyle = (color2) => ({
  ...baseStyles.span,
  backgroundSize: "100% 0",
  backgroundImage: createSolidGradient(color2)
});
const slideColorMap = {
  red: color.red,
  black: color.black,
  white: color.white,
  gold: color.gold
};
const fadeColorMap = {
  red: color.red,
  gray: color.gray.mediumAA,
  gold: color.gold,
  black: color.black,
  white: color.white
};
function composeSlideUnder(options) {
  const { color: colorOption = "red" } = options || {};
  let composed = {
    ...baseStyles.link
  };
  if (colorOption === "gray-red") {
    composed = {
      ...composed,
      [`&:hover > *:not(svg):not(.sr-only),
        &:focus > *:not(svg):not(.sr-only)`]: {
        backgroundPosition: "left bottom",
        backgroundSize: "200% 2px"
      },
      "& > *:not(svg):not(.sr-only)": getSlideUnderTwoColorStyle(
        color.gray.light,
        color.red
      )
    };
  } else if (colorOption === "graydark-red") {
    composed = {
      ...composed,
      [`&:hover > *:not(svg):not(.sr-only),
        &:focus > *:not(svg):not(.sr-only)`]: {
        backgroundPosition: "left bottom",
        backgroundSize: "200% 2px"
      },
      "& > *:not(svg):not(.sr-only)": getSlideUnderTwoColorStyle(
        color.gray.dark,
        color.red
      )
    };
  } else {
    const colorValue = slideColorMap[colorOption];
    composed = {
      ...composed,
      [`&:hover > *:not(svg):not(.sr-only),
        &:focus > *:not(svg):not(.sr-only)`]: {
        backgroundSize: "100% 2px"
      },
      "& > *:not(svg):not(.sr-only)": getSlideUnderStyle(colorValue)
    };
  }
  const className = `${classNamePrefix}-slide-${colorOption}`;
  const deprecatedAliases = [];
  if (colorOption === "red") {
    deprecatedAliases.push("umd-slidein-underline-red");
  } else if (colorOption === "black") {
    deprecatedAliases.push("umd-slidein-underline-black");
  } else if (colorOption === "white") {
    deprecatedAliases.push("umd-slidein-underline-white");
  } else if (colorOption === "gold") {
    deprecatedAliases.push("umd-slidein-underline-gold");
  } else if (colorOption === "gray-red") {
    deprecatedAliases.push("umd-slidein-underline-gray-red");
  } else if (colorOption === "graydark-red") {
    deprecatedAliases.push("umd-slidein-underline-graydark-red");
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
function composeFadeUnder(options) {
  const { color: colorOption = "red" } = options || {};
  const colorValue = fadeColorMap[colorOption];
  const composed = {
    ...baseStyles.link,
    [`&:hover > *:not(svg):not(.sr-only),
      &:focus > *:not(svg):not(.sr-only)`]: {
      backgroundSize: "100% 2px"
    },
    "& > *:not(svg):not(.sr-only)": getFadeUnderStyle(colorValue)
  };
  const className = `${classNamePrefix}-fade-${colorOption}`;
  const deprecatedAliases = [];
  if (colorOption === "red") {
    deprecatedAliases.push("umd-fadein-underline-red");
  } else if (colorOption === "gray") {
    deprecatedAliases.push("umd-fadein-underline-gray");
  } else if (colorOption === "gold") {
    deprecatedAliases.push("umd-fadein-underline-gold");
  } else if (colorOption === "black") {
    deprecatedAliases.push("umd-fadein-underline-black");
  } else if (colorOption === "white") {
    deprecatedAliases.push("umd-fadein-underline-white");
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
function composeFadeInSimple(options) {
  const { theme = "light" } = options || {};
  let composed = {
    ...baseStyles.link
  };
  if (theme === "dark") {
    composed = {
      ...composed,
      backgroundImage: createSolidGradient(color.white),
      backgroundPosition: "left calc(100% - 1px)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 1px",
      color: color.white,
      transition: "color 0.5s, background-image 0.5s, background-position 0.5s",
      [`&:hover, &:focus`]: {
        backgroundImage: createSolidGradient(color.gold),
        backgroundPosition: "left calc(100%)",
        color: color.white,
        textDecoration: "none"
      }
    };
  } else {
    composed = {
      ...composed,
      backgroundImage: createSolidGradient("currentColor"),
      backgroundPosition: "left calc(100% - 1px)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 1px",
      color: "currentColor",
      transition: "color 0.5s, background-image 0.5s, background-position 0.5s",
      [`&:hover, &:focus`]: {
        backgroundImage: createSolidGradient(color.red),
        backgroundPosition: "left calc(100%)",
        color: color.red,
        textDecoration: "none"
      }
    };
  }
  const className = `umd-fadein-simple-${theme}`;
  return objectWithClassName({
    ...composed,
    className
  });
}
const slideUnderRed = composeSlideUnder({ color: "red" });
const slideUnderBlack = composeSlideUnder({ color: "black" });
const slideUnderWhite = composeSlideUnder({ color: "white" });
const slideUnderGold = composeSlideUnder({ color: "gold" });
const slideUnderGrayRed = composeSlideUnder({ color: "gray-red" });
const slideUnderGrayDarkRed = composeSlideUnder({ color: "graydark-red" });
const fadeUnderRed = composeFadeUnder({ color: "red" });
const fadeUnderGray = composeFadeUnder({ color: "gray" });
const fadeUnderGold = composeFadeUnder({ color: "gold" });
const fadeUnderBlack = composeFadeUnder({ color: "black" });
const fadeUnderWhite = composeFadeUnder({ color: "white" });
const fadeInSimpleDark = composeFadeInSimple({ theme: "dark" });
const fadeInSimpleLight = composeFadeInSimple({ theme: "light" });
export {
  composeFadeInSimple,
  composeFadeUnder,
  composeSlideUnder,
  fadeInSimpleDark,
  fadeInSimpleLight,
  fadeUnderBlack,
  fadeUnderGold,
  fadeUnderGray,
  fadeUnderRed,
  fadeUnderWhite,
  slideUnderBlack,
  slideUnderGold,
  slideUnderGrayDarkRed,
  slideUnderGrayRed,
  slideUnderRed,
  slideUnderWhite
};
//# sourceMappingURL=line.js.map
